import Skeleton from "@mui/material/Skeleton";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";

export default function ReportTableSkeleton() {
  return (
    <>
      <Grid container spacing={2}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Grid key={i} size={i === 0 ? 2 : i === 1 ? 3 : 3.5}>
            <Paper
              sx={{
                borderRadius: "12px",
                p: 2,
                border: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Stack spacing={1}>
                <Skeleton variant="text" width="50%" height={20} />
                <Skeleton variant="rounded" width="100%" height={60} />
                <Skeleton variant="rounded" width="100%" height={60} />
                <Skeleton variant="rounded" width="80%" height={60} />
              </Stack>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <TableContainer
        sx={{
          borderRadius: "12px",
          mt: "24px",
          border: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Table>
          <TableBody>
            {Array.from({ length: 10 }).map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {Array.from({ length: 15 }).map((__, colIndex) => (
                  <TableCell key={colIndex}>
                    <Skeleton
                      variant="text"
                      width={`${50 + Math.random() * 30}%`}
                      height={24}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box display="flex" justifyContent="flex-end" p={2}>
        <Skeleton variant="rounded" width={160} height={36} />
      </Box>
    </>
  );
}
